import * as React from 'react';
import { JSONController, URLData } from '@telia-common-components/shared';
import { withAnalytics } from '../util/AnalyticsUtil';
import { TvChannelComparisonContext } from './TvChannelComparisonContext';
class TvChannelComparisonProvider extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            channelsResponse: {
                packagePrices: [],
                packageNames: [],
                channelInclusions: []
            },
            channelState: 'UNINITIALIZED',
            selectedPackage: ''
        };
        this.jsonController = new JSONController();
        this.urlData = new URLData({
            app: 'public',
            tier: this.props.tier,
            lang: this.props.lang
        });
        this.getChannels = async () => {
            try {
                this.setState({ channelState: 'FETCHING' });
                const response = await this.jsonController.fetch(this.urlData.getTvChannelComparisonDataUrl(this.props.lang));
                await this.handleChannelsResponse(response);
            }
            catch (e) {
                this.setState({
                    channelsResponse: {
                        packagePrices: [],
                        packageNames: [],
                        channelInclusions: []
                    }
                });
                console.error(e);
                this.setState({ channelState: 'ERROR' });
            }
        };
        this.setSelectedPackage = (val) => {
            this.setState({
                selectedPackage: val
            });
            if (val) {
                this.props.pushAnalytics(`Selected package ${val}`);
            }
        };
    }
    componentDidMount() {
        this.getChannels();
    }
    handleChannelsResponse(response) {
        this.setState({
            channelsResponse: response,
            channelState: 'FETCHED'
        });
    }
    render() {
        const { children } = this.props;
        return (React.createElement(TvChannelComparisonContext.Provider, { value: {
                packagePrices: this.state.channelsResponse.packagePrices,
                packageNames: this.state.channelsResponse.packageNames,
                channelInclusions: this.state.channelsResponse.channelInclusions,
                channelState: this.state.channelState,
                selectedPackage: this.state.selectedPackage,
                setSelectedPackage: this.setSelectedPackage,
                urlData: this.urlData
            } }, children));
    }
}
export default withAnalytics(TvChannelComparisonProvider);
